import { IRackEditComponentProps } from "./RackEditComponent.props";
import cn from "classnames";
import styles from "./RackEditComponent.module.scss";
import { useRackEditComponentControl } from "./useRackEditComponentControl";
import { makeGrid } from "@utils/makeGrid";
import Error from "../../../../global/new/Error/Error";
import MinerSection from "./MinerSection/MinerSection";
import { xyPositionRackItem } from "@utils/xyPositionRackItem";
import WithErrorBoundry from "@components/ErrorBoundry/WithErrorBoundry/WithErrorBoundry";
import { RACK_UNIT } from "../../../../../config";
import NumberOfColumn from "@components/global/new/NumberOfColumn/NumberOfColumn";
import { useIntl } from "react-intl";
import { Button } from "antd";

function RackEditComponent({ ...props }: IRackEditComponentProps) {
  const { type } = props;
  const { formatMessage } = useIntl();
  const control = useRackEditComponentControl(props);

  return (
    <div className={styles.wrapper}>
      <h5>{control.title}</h5>

      <div
        className={styles.rack}
        style={{
          gridTemplateColumns: makeGrid(type[0], `${2 * RACK_UNIT}px`),
          gridTemplateRows: makeGrid(type[1], "52px"),
          justifyContent: type[0] > 10 ? undefined : "center",
        }}
      >
        {control.rackSections.map((item, i) => {
          const currentIndex = props.reversed
            ? control.rackSections.length - 1 - i
            : i;
          const [X, Y] = xyPositionRackItem(currentIndex, props.type);

          return (
            <NumberOfColumn
              rack_type={type}
              index={i}
              reversed={props.reversed}
              key={i}
            >
              <MinerSection
                item={item}
                position={[X, Y]}
                isActive={control.isActive(i)}
                onClick={control.onSelectSection.bind({}, i, [X, Y])}
              />
            </NumberOfColumn>
          );
        })}
      </div>

      {control.err && <Error errors={control.err} />}
      <Button
        className={styles.btn}
        onClick={control.onCreateOrEdit}
        disabled={!!control.err}
        loading={control.loading}
        type="primary"
      >
        {control.isEdit
          ? formatMessage({ id: "modal.equipment.btn_save" })
          : formatMessage({ id: "modal.create_object.btn" })}
      </Button>
    </div>
  );
}

export default WithErrorBoundry(RackEditComponent);
